import ViewSwitchUser from './SwitchUser/ViewSwitchUser';
import ViewCreateUser from './CreateUser/ViewCreateUser';
import { useParams } from 'react-router-dom';

const RBACManagement = () => {
  const { memberType, type, viewType, request_id } = useParams();

  const isSwitchUser = type === 'switch-user';
  const isCreateUser = type === 'create-user';
  return (
    <div>
      {isSwitchUser && <ViewSwitchUser />}
      {isCreateUser && <ViewCreateUser />}
    </div>
  );
};

export default RBACManagement;
